import { Usage } from 'projects/shared-lib/src/public-api';

export class UsageRequest {
  constructor(public usageList: Usage[]) {}
}
